export default __webpack_public_path__ + "static/media/PPI-pools-003.0f318744.jpg";